<div [@routerTransition]>
    <div id="kt_header_mobile" class="kt-header-mobile">
        <div class="kt-header-mobile__logo">
            <a  href="javascript:;" (click)="goHome()">
                <img *ngIf="!appSession.tenant || !appSession.tenant.logoId"
                     [src]="'/assets/common/images/app-logo-on-light.svg'" alt="logo" height="28"/>
                <img *ngIf="appSession.tenant && appSession.tenant.logoId"
                     [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=' + currentTheme.baseSettings.menu.asideSkin + '&tenantId=' + appSession.tenant.id + '&id=' + appSession.tenant.logoId"
                     alt="logo" height="38"/>
            </a>
        </div>
        <div class="kt-header-mobile__toolbar">
            <ng-container *ngIf="false; else newMobileTopbar">
                <button class="kt-header-mobile__toolbar-toggler" id="kt_header_mobile_toggler">
                    <span></span>
                </button>

                <button ktToggle [options]="userMenuToggleOptions" class="kt-header-mobile__toolbar-topbar-toggler"
                        id="kt_header_mobile_topbar_toggler">
                    <i class="flaticon-more-1"></i>
                </button>
            </ng-container>

            <ng-template #newMobileTopbar>
                <div class="mobile-toolbar-with-topbar">
                    <topbar></topbar>
                    <button class="kt-header-mobile__toolbar-toggler" id="kt_header_mobile_toggler">
                        <span></span>
                    </button>
                </div>
            </ng-template>

        </div>
    </div>

    <div class="kt-grid kt-grid--hor kt-grid--root kt-page-content-white">
        <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
            <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">

                <!-- begin:: Header -->
                <div id="kt_header" ktHeader #ktHeader class="kt-header kt-grid__item" data-ktheader-minimize="1">
                    <div class="kt-header__top">
                        <div [class]="containerClass">
                            <!-- begin:: Brand -->
                            <theme12-brand></theme12-brand>
                            <!-- end:: Brand -->
                            <!-- begin:: Header Topbar -->
                            <topbar></topbar>
                            <!-- end:: Header Topbar -->
                        </div>
                    </div>
                    <div class="kt-header__bottom with-search">
                        <div [class]="containerClass">
                            <!-- begin: Header Menu -->
                            <top-bar-menu [isTabMenuUsed]="false" style="width: 100%"></top-bar-menu>
                            <!-- end: Header Menu -->
                        </div>
                    </div>
                </div>

                <!-- end:: Header -->
                <div class="d-lg-none p-3 mobile-subscription-warning">
                    <div *ngIf="subscriptionStatusBarVisible()"
                         [ngClass]="{'hidden': !subscriptionStatusBarVisible()}" class="d-inline-block d-sm-none m-3">
                        <span *ngIf="tenant.isInTrialPeriod && !subscriptionIsExpiringSoon()"
                              [innerHTML]="getTrialSubscriptionNotification()"></span>
                        <a *ngIf="subscriptionIsExpiringSoon()" routerLink="/app/admin/subscription-management">
                            <span *ngIf="subscriptionIsExpiringSoon() && tenant.isInTrialPeriod"><i
                                class="fa fa-exclamation-circle"></i> {{ getExpireNotification("TrialExpireNotification") }}</span>
                            <span *ngIf="subscriptionIsExpiringSoon() && !tenant.isInTrialPeriod"><i
                                class="fa fa-exclamation-circle"></i> {{ getExpireNotification("SubscriptionExpireNotification") }}</span>
                        </a>
                    </div>
                </div>

                <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" *ngIf="showStates || isSearchAvailable">
                    <ng-container *ngIf="showStates">
                        <app-order-state></app-order-state>
                    </ng-container>

                    <ng-container *ngIf="isSearchAvailable && !isGuided">
                        <div class="mb-5 mt-5 d-flex p-justify-center p-align-center">
                            <div class="search-bar-container" [formGroup]="searchForm">
                                  <span class="p-input-icon-left">
                                        <i class="ml-3 pi pi-search"></i>

                                        <input
                                            type="text"
                                            pInputText
                                            formControlName="filter"
                                            [placeholder]="l('SearchWithThreeDot')"
                                            class="pl-5 form-control search-input"/>

                                        <button *ngIf="query" (click)="clearInput()" class="clear-btn">
                                          <i class="pi pi-times"></i>
                                        </button>
                                  </span>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                    <router-outlet></router-outlet>
                </div>

            </div>
        </div>
    </div>
    <kt-scroll-top></kt-scroll-top>
</div>
